var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.166016,
    width: 45.67,
    height: 45.6684,
    rx: 17,
    fill: "#53B175"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.335 23C31.335 23.3758 31.1908 23.7391 30.9214 24.0022C30.6582 24.2716 30.2948 24.4219 29.9188 24.4219H24.2542V30.0844C24.2542 30.4602 24.1039 30.8235 23.8344 31.0866C23.5712 31.3497 23.2141 31.5 22.8381 31.5C22.4621 31.5 22.0987 31.3497 21.8355 31.0866C21.5661 30.8235 21.4157 30.4602 21.4157 30.0844V24.4219H15.7511C15.3751 24.4219 15.0117 24.2716 14.7485 24.0022C14.4853 23.7391 14.335 23.3758 14.335 23C14.335 22.6242 14.4853 22.2671 14.7485 21.9978C15.0117 21.7347 15.3751 21.5844 15.7511 21.5844H21.4157V15.9219C21.4157 15.5461 21.5661 15.1828 21.8355 14.9197C22.0987 14.6503 22.4621 14.5 22.8381 14.5C23.2141 14.5 23.5712 14.6503 23.8344 14.9197C24.1039 15.1828 24.2542 15.5461 24.2542 15.9219V21.5844H29.9188C30.2948 21.5844 30.6582 21.7347 30.9214 21.9978C31.1908 22.2671 31.335 22.6242 31.335 23Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/add-card.c8d2b10cde49ccf16dd0b0fa7e25a352.svg";
export { ForwardRef as ReactComponent };